import { lazy } from "react";
import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ContactPage from "../pages/contact/page";
import AboutPage from "../pages/about/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";
import GuidePage from "../pages/guide/page";
import DownloadPage from "../pages/download/page";
import ExperiencePage from "../pages/experience/page";
import BaziExperiencePage from "../pages/experience/pages/BaziExperiencePage";
import ZodiacExperiencePage from "../pages/experience/pages/ZodiacExperiencePage";
import TarotExperiencePage from "../pages/experience/pages/TarotExperiencePage";
import ShengxiaoExperiencePage from "../pages/experience/pages/ShengxiaoExperiencePage";
import ZiweiExperiencePage from "../pages/experience/pages/ZiweiExperiencePage";
import FunExperiencePage from "../pages/experience/pages/FunExperiencePage";
import FunToolExperiencePage from "../pages/experience/pages/FunToolExperiencePage";
import LoginPage from "../pages/login/page";
import ComingSoon from "../pages/ComingSoon";
import RequireAuth from "./RequireAuth";
// 二期同步模块（懒加载）
const ProfileManagePage = lazy(() => import("../pages/profileManage/page"));
const TarotDetailPage = lazy(() => import("../pages/tarotDetail/page"));
const ShengbeiPage = lazy(() => import("../pages/shengbei/page"));
const LingbaiPage = lazy(() => import("../pages/lingbai/page"));
const AstroDicePage = lazy(() => import("../pages/astroDice/page"));
const GuaqianPage = lazy(() => import("../pages/guaqian/page"));
const ZhouyiDetailPage = lazy(() => import("../pages/zhouyiDetail/page"));
const ZodiacDetailPage = lazy(() => import("../pages/zodiacDetail/page"));
const ShicaoPage = lazy(() => import("../pages/shicao/page"));
const LiuyaoPage = lazy(() => import("../pages/liuyao/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/download",
    element: <DownloadPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/guide",
    element: <GuidePage />,
  },
  {
    path: "/experience",
    element: <ExperiencePage />,
  },
  {
    path: "/experience/bazi",
    element: <BaziExperiencePage />,
  },
  {
    path: "/experience/zodiac",
    element: <ZodiacExperiencePage />,
  },
  {
    path: "/experience/tarot",
    element: <TarotExperiencePage />,
  },
  {
    path: "/experience/shengxiao",
    element: <ShengxiaoExperiencePage />,
  },
  {
    path: "/experience/ziwei",
    element: <ZiweiExperiencePage />,
  },
  {
    path: "/experience/fun",
    element: <FunExperiencePage />,
  },
  {
    path: "/experience/fun/:toolId",
    element: <FunToolExperiencePage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/profile-manage",
    element: (
      <RequireAuth>
        <ProfileManagePage />
      </RequireAuth>
    ),
  },
  {
    path: "/tarot-detail",
    element: <TarotDetailPage />,
  },
  {
    path: "/shengbei",
    element: <ShengbeiPage />,
  },
  {
    path: "/lingbai",
    element: <LingbaiPage />,
  },
  {
    path: "/astro-dice",
    element: <AstroDicePage />,
  },
  {
    path: "/guaqian",
    element: <GuaqianPage />,
  },
  {
    path: "/zhouyi-detail",
    element: <ZhouyiDetailPage />,
  },
  {
    path: "/zodiac-detail",
    element: <ZodiacDetailPage />,
  },
  {
    path: "/shicao",
    element: <ShicaoPage />,
  },
  {
    path: "/shicaoi",
    element: <Navigate to="/shicao" replace />,
  },
  {
    path: "/liuyao",
    element: <LiuyaoPage />,
  },
  {
    path: "/profileManage",
    element: <Navigate to="/profile-manage" replace />,
  },
  {
    path: "/rule-settings",
    element: <ComingSoon />,
  },
  {
    path: "/fortune-analysis",
    element: <ComingSoon />,
  },
  {
    path: "/profile",
    element: <ComingSoon />,
  },
  {
    path: "/member_benefits",
    element: <ComingSoon />,
  },
  {
    path: "/vip",
    element: <ComingSoon />,
  },
  {
    path: "/liuyao-report",
    element: <ComingSoon />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
